import ViewWebshopBlock from './ViewWebshopBlock'

export default ViewWebshopBlock
